import React from 'react';
import Landing from './pages/Landing';

const App: React.FC = () => (
  <Landing />
);

export default App;
